import { __rest } from "tslib";
import * as React from 'react';
import { createContext, useContext } from 'react';
var ApiClientContext = createContext({
    portal: null,
    resolve: null,
    s3Proxy: null,
    content: null
});
export var ApiClientProvider = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return React.createElement(ApiClientContext.Provider, { value: rest, children: children });
};
export function useApiClient() {
    return useContext(ApiClientContext);
}
